<template>
    <v-container fluid  fill-height style="padding:0px 10px 5px 10px;width:100%;height:100%;">
        <v-layout column>
            <v-flex >
                <v-card>
                    <v-card-title  primary class="title" style="height:5%;width:100%;padding-top:5px;padding-bottom:10px;">Subsystem KPIs</v-card-title>
                    <v-card-actions  fill-height style="height:95%;width:100%;padding-top:0px;padding-bottom:10px;">
                        <dx-data-grid class="grid" :data-source="sysKpiGrid" :show-column-lines="true" :show-row-lines="true" :show-borders="true" :word-wrap-enabled="true" :row-alternation-enabled="false" :column-auto-width="true" >
                            <dx-column data-field="engType" caption=""/>
                            <dx-column v-for="sys in subSystems.slice(0, 3)" :key="sys" :data-field="sys.tag" :caption="sys.name" format="percent"/>
                            <dx-sorting mode="none"/>
                        </dx-data-grid>
                    </v-card-actions>
                    <v-card-actions  fill-height style="height:95%;width:100%;padding-top:0px;padding-bottom:10px;">
                        <dx-data-grid class="grid" :data-source="sysKpiGrid" :show-column-lines="true" :show-row-lines="true" :show-borders="true" :word-wrap-enabled="true" :row-alternation-enabled="false" :column-auto-width="true">
                            <dx-column data-field="engType" caption="" />
                            <dx-column v-for="sys in subSystems.slice(3, 6)" :key="sys" :data-field="sys.tag" :caption="sys.name" format="percent" />
                            <dx-sorting mode="none"/>
                        </dx-data-grid>
                    </v-card-actions>
                </v-card>
            </v-flex>
            <v-flex >
                <v-layout column>
                    <v-flex  style="max-height:50%;">
                        <v-card fill-height :flat="flat" style="height:100%;width:100%;">
                            <v-card-title   class="title" style="height:15%;width:100%;padding-top:5px;padding-bottom:5px;">Most Frequent Issues</v-card-title>
                            <v-card-actions fill-height style="height:80%;width:100%;padding-top:0px;padding-bottom:0px;">
                                <v-layout >
                                    <v-flex v-for="sys in subSystems.slice(0, 3)" :key="sys" :style='"max-width:"+(100/3)+"%;"'>
                                        <ChartFrequentIssues v-if="chartData[sys.tag]" v-bind:chartOptions="chartData[sys.tag]" v-bind:title="sys.name" v-bind:active="active" v-bind:flat="true"/>
                                    </v-flex>
                                </v-layout>
                            </v-card-actions>
                            <v-card-actions fill-height style="height:80%;width:100%;padding-top:0px;padding-bottom:0px;">
                                <v-layout >
                                    <v-flex v-for="sys in subSystems.slice(3, 6)" :key="sys" :style='"max-width:"+(100/3)+"%;"'>
                                        <ChartFrequentIssues v-if="chartData[sys.tag]" v-bind:chartOptions="chartData[sys.tag]" v-bind:title="sys.name" v-bind:active="active" v-bind:flat="true"/>
                                    </v-flex>
                                </v-layout>
                            </v-card-actions>
                        </v-card>
                    </v-flex>
                    <v-flex style="max-height:50%;">
                        <v-card>
                            <Chart v-if="chartData['issues']" v-bind:chartOptions="chartData['issues']" v-bind:title="'Issues / Subsystem'" v-bind:active="active"/>
                        </v-card>
                    </v-flex>
                </v-layout>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
    import Chart from '../components/Chart'
    import ChartFrequentIssues from '../components/ChartFrequentIssues'
    import { DxDataGrid, DxColumn, DxPaging, DxScrolling, DxSorting} from 'devextreme-vue/data-grid';

    export default {
        name: "SubsystemsOverview",
        components: {
            DxDataGrid,
            DxColumn,
            DxPaging,
            DxScrolling,
            DxSorting,
            Chart,
            ChartFrequentIssues
        },
        data () {
            return {
                chartData:{},
                subSystems:[
                    {
                        name:'Servo Oil',
                        tag:'so'
                    },
                    {
                        name:'Fuel Injection',
                        tag:'fi'
                    },
                    {
                        name: 'Scavenge Air',
                        tag:'sac'
                    },
                    {
                        name:'Exhaust Gas',
                        tag:'egs'
                    },
                    {
                        name:'Piston Running',
                        tag:'pr'
                    },
                    {
                        name:'Gas Admission',
                        tag:'gas'
                    }
                ],
                sysKpiGrid:[],
            }
        },
        props: {
            active:Boolean,
            subSysData:Object
        },
        computed: {},
        created() {},
        mounted() {
            setTimeout(() => {
                this.setData();
            });
        },
        methods: {
            gridClick(e) {
                if (e.rowType=="header") {
                    this.$emit('sysSelected',e.column.caption);
                }
            },
            cellPrepared(e) {
                if (e.rowType=="header") {
                    e.cellElement.classList.add('clickable');
                }
            },
            setData() {
                this.$set(this.chartData,'issues',{
                    chart:{
                        height:0,
                        zoomType: 'xy'
                    },
                    legend:{
                        enabled:false
                    },
                    xAxis:{
                        categories:this.subSystems.map(function (item) {
                            return item.name;
                        }),
                        crosshair:true
                    },
                    yAxis:{
                        title: {
                            text:undefined
                        }
                    },
                    exporting:{
                        enabled : false
                    },
                    title:{
                        text:undefined
                    },
                    series: [{
                        type:'column',
                        animation: false,
                        data:[],
                        states: {
                            hover: {
                                enabled: false
                            },
                            normal:{
                                animation:false
                            },
                            inactive:{
                                opacity: 1
                            }
                        }
                    }],
                    tooltip: {
                        formatter: function () {
                            return this.x + ': ' + this.point.y.toFixed(1);
                        }
                    },
                    credits: {enabled: false}
                });

                for (let i=0;i<this.subSystems.length;i++) {
                    this.chartData['issues'].series[0].data.push({
                        y:this.subSysData[this.subSystems[i].name][this.subSystems[i].tag+'FaultNo'],
                        color:'rgb(144,170,218)'});
                }

                let engineTypes = Object.keys(this.subSysData['Servo Oil'].engineTypes);

                this.sysKpiGrid = [];
                for (let i=0;i<engineTypes.length;i++) {
                    var temp = {'engType': engineTypes[i]};

                    for (let j=0;j<this.subSystems.length;j++) {
                        if (Object.keys(this.subSysData[this.subSystems[j].name].engineTypes).includes(engineTypes[i])) {
                            var kpi = this.subSysData[this.subSystems[j].name].engineTypes[engineTypes[i]][this.subSystems[j].tag + '_KPI'];

                            kpi = ((kpi != -1000 && kpi >= 0) ? kpi : '-');
                            temp[this.subSystems[j].tag] = kpi;
                        }
                    }

                    this.sysKpiGrid.push(temp);
                }

                for (let i=0;i<this.subSystems.length;i++) {
                    this.$set(this.chartData,this.subSystems[i].tag,{
                        chart:{
                            height:0,
                        },
                        legend:{
                            enabled:false
                        },
                        exporting:{
                            enabled : false
                        },
                        title:{
                            text:undefined
                        },
                        plotOptions: {
                            pie: {
                                shadow: false,
                                center: ['50%', '50%'],
                                dataLabels: {
                                    enabled: false
                                },
                            }
                        },
                        series: [{
                            type:'pie',
                            animation: false,
                            data: [],
                            size: '100%',
                            innerSize: '70%',
                            states: {
                                hover: {
                                    enabled: false
                                },
                                normal:{
                                    animation:false
                                },
                                inactive:{
                                    opacity: 1
                                }
                            }
                        }],
                        tooltip: {
                            formatter: function () {
                                return this.point.name + ': ' + this.point.y.toFixed(1);
                            }
                        },
                        credits: {enabled: false}
                    });

                    let topFaults = this.subSysData[this.subSystems[i].name].topFaults;

                    for (let j=0;j<topFaults.length;j++) {
                        this.chartData[this.subSystems[i].tag].series[0].data.push({
                            y:Number(topFaults[j].percentage),
                            name:topFaults[j].description
                        });
                    }
                }
            }
        },
        watch: {
            subSysData:function() {
                setTimeout(() => {
                    this.setData();
                });
            }
        }
    }
</script>

<style scoped>

</style>
